var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckMarkWithoutBg = function SvgCheckMarkWithoutBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.31 7.234a.75.75 0 0 1-.029 1.06L11.15 16.24a1.728 1.728 0 0 1-2.363-.001l-3.552-3.37a.75.75 0 0 1 1.032-1.088l3.552 3.37a.216.216 0 0 0 .15.055.215.215 0 0 0 .15-.055l7.132-7.945a.75.75 0 0 1 1.06.03Z",
    fill: "currentColor"
  })));
};
export default SvgCheckMarkWithoutBg;